var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
const sortRefs = (formId) => (a, b) => {
    const formEl = document.getElementById(formId);
    const idxA = Array.prototype.indexOf.call(formEl, a.current);
    const idxB = Array.prototype.indexOf.call(formEl, b.current);
    return idxA - idxB;
};
export const useErrorFocus = ({ formId, isValid, isSubmitting, submitCount, }) => {
    const [formError, setFormError] = React.useState('');
    const formErrorRef = React.useRef(null);
    const [errorRefs, setErrorRefs] = React.useState({});
    const [submissions, setSubmissions] = React.useState(submitCount);
    const createRef = () => {
        const refKey = uuidv4();
        const refValue = React.createRef();
        return [refKey, refValue];
    };
    const registerError = (refKey, refValue) => {
        setErrorRefs(prevRefs => {
            const alreadyExists = Object.prototype.hasOwnProperty.call(prevRefs, refKey);
            if (alreadyExists)
                return prevRefs;
            return Object.assign(Object.assign({}, prevRefs), { [refKey]: refValue });
        });
    };
    const deregisterError = (refKey) => {
        setErrorRefs(prevRefs => {
            const alreadyExists = Object.prototype.hasOwnProperty.call(prevRefs, refKey);
            if (!alreadyExists)
                return prevRefs;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _a = prevRefs, _b = refKey, _ = _a[_b], others = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return others;
        });
    };
    const sortedErrorRefs = Object.values(errorRefs).sort(sortRefs(formId));
    const focusOnError = () => {
        const isSingleRef = sortedErrorRefs.length === 1;
        const areMultiRefs = sortedErrorRefs.length > 1;
        const firstRef = sortedErrorRefs[0];
        if (isSingleRef && (firstRef === null || firstRef === void 0 ? void 0 : firstRef.current)) {
            return firstRef.current.focus();
        }
        if (areMultiRefs && (formErrorRef === null || formErrorRef === void 0 ? void 0 : formErrorRef.current)) {
            setFormError(`There are ${sortedErrorRefs.length} errors in the form you submitted.`);
            return formErrorRef.current.focus();
        }
        if (firstRef === null || firstRef === void 0 ? void 0 : firstRef.current) {
            return firstRef.current.focus();
        }
        return undefined;
    };
    React.useEffect(() => {
        // do nothing if it's not a submission
        if (submitCount === submissions)
            return;
        setFormError('');
        /**
         * If the consumer calls resetForm from Formik, then submitCount will become
         * 0. This block handles that scenario by resetting the local submissions
         * count.
         */
        if (submitCount === 0) {
            setSubmissions(0);
            return;
        }
        // unsuccessful submission
        if (!isSubmitting && !isValid) {
            focusOnError();
            setSubmissions(submitCount);
        }
    }, [isValid, isSubmitting, submitCount, submissions, sortedErrorRefs]);
    return {
        focusOnError,
        formError,
        formErrorRef,
        formId,
        setFormError,
        createRef,
        registerError,
        deregisterError,
    };
};
//# sourceMappingURL=useErrorFocus.js.map